import React, { useEffect, useState } from "react";

import { Icon } from "atoms/icon/Icon";
import Info from "atoms/icon/icons/info.svg";

interface Props {
  title: string;
  price?: string;
}

export const ServiceFeeRow: React.FC<Props> = ({ title, price }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => {
      if (show) {
        setShow(false);
      }
    };
    document.addEventListener("click", handler);

    return () => {
      document.removeEventListener("click", handler);
    };
  }, [show]);

  return (
    <div className="relative text-body3">
      {show && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 rounded bg-nearly-black p-3 text-center font-sans text-white">
          A small convenience fee supports platform maintenance, secure payment
          processing, customer service, and ongoing improvements to enhance your
          experience with the RepeatMD app.
        </div>
      )}
      <div className="flex justify-center py-2">
        <button
          type="submit"
          className="inline-flex items-center justify-center gap-1 text-secondary"
          onClick={(event) => {
            event.stopPropagation();
            setShow(!show);
          }}
        >
          {title}
          <Icon svg={Info} size="x2small" color="secondaryText" />
        </button>
        {price && <div>{price}</div>}
      </div>
    </div>
  );
};
